import settingApi from 'api/settingApi';

export const getAlertSetting = async (params: any = {}) => {
  try {
    const response = await settingApi.getAlertSetting(params)
    return response;
  } catch (error) {
    return error;
  }
};


export const postAlertSetting = async (data: any = {}) => {
  try {
    const response = await settingApi.postAlertSetting(data);
    return response;
  } catch (error) {
    return error;
  }
};
